import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import supabase from '../../supabase';
import { Container, Row, Col, Card, Button, Form } from 'react-bootstrap';
import './Signup.css'; // Import the new CSS file
import { useNotification } from '../../context/NotificationContext';

const Signup = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const desiredPlan = searchParams.get("plan"); // 'pro' si transmis
  const { showNotification } = useNotification();

  const handleSignup = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      showNotification('Les mots de passe ne correspondent pas.', 'warning');
      return;
    }

    try {
      const { error } = await supabase.auth.signUp({ email, password });
      if (error) throw error;

      showNotification('Compte créé avec succès ! Vérifiez votre email pour confirmer.', 'success');
      navigate('/login?plan=' + desiredPlan);
    } catch (error) {
      showNotification('Erreur lors de la création du compte : ' + error.message, 'danger');
    }
  };

  const signInWithGoogle = async () => {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
      });
      if (error) {
        showNotification(`Erreur lors de la connexion avec Google : ${error.message}`, 'danger');
      }
      // Supabase handles redirection, so no navigate() call is needed here.
    } catch (error) {
      showNotification('Une erreur inattendue est survenue.', 'danger');
    }
  };

  return (
    <Container className="signup-container">
      <Row className="justify-content-center">
        <Col>
          <Card className="signup-card">
            <Card.Body>
              <h2 className="text-center signup-title">Créer un compte</h2>
              <Form onSubmit={handleSignup}>
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Entrez votre email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formPassword">
                  <Form.Label>Mot de passe</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Entrez un mot de passe"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formConfirmPassword">
                  <Form.Label>Confirmer le mot de passe</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Confirmez votre mot de passe"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </Form.Group>

                <Button
                  type="submit"
                  variant="primary"
                  className="w-100 signup-button"
                >
                  Créer un compte
                </Button>
              </Form>
              <div className="text-center mt-3">
                <p>
                  Déjà inscrit ?{' '}
                  <Button variant="link" onClick={() => navigate('/login')} className="login-link-button">
                    Se connecter
                  </Button>
                </p>
              </div>
              <div className="divider-ou"><span>ou</span></div>
              <Button
                variant="secondary"
                className="w-100 google-signin-button"
                onClick={signInWithGoogle}
              >
                <img src="/google-48.png" alt="Google icon" style={{ marginRight: '10px', width: '18px', height: '18px' }} />
                S'inscrire avec Google
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Signup;